<div class="container">
  <div class="row">
    <div class="col-md-6" style="color:black; padding-top:1%; font-size:1.4em; font-weight:bold ">
      In re Generic Pharmaceuticals Antitrust Litigation
    </div>
    <div class="col-md-6">
      <div class="float-right phoneNumber" style="font-size: 1.4em; padding-top: 3%; font-weight: bold">1-877-316-0171</div>
    </div>
  </div>
</div>
<div class="container" style="border:1px solid #bebaba">
  <div style="margin-top:2%; margin-bottom:5%">
    <h2 class="text-center">Register</h2>
    <br />
    <div class="row">
      <div class="col-md-2">
      </div>
      <div class="col-md-1">
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header text-center" style="font-weight:bold; font-size:1.4em">
            Third-party Payor <span>(consumption by their members, employees, insureds, participants, or beneficiaries)</span>
          </div>
          <div class="card-body text-center no-padding">
            <p>This form is to be filled out on behalf of a third-party payor, not individual consumers.</p>
            <div class="row text-center">
              <div class="col-md-12">
                <a routerLink="/register" class="btn btn-primary">Register Now</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-1">
      </div>
      <div class="col-md-2">
      </div>
    </div>
  </div>
</div>
